import Layout from "@/views/layout/LayoutContainer.ts";
import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";

function App() {
  return (
    <Router>
      <Layout></Layout>
    </Router>
  );
}

export default App;
